// import { EventBus } from '../event-bus';

export default {
    data() {
        return {
            user: this.$store.state.auth.user,
            locale: "mm",
            localeChangeCallback: null,
        };
    },

    mounted() {
        let locale = this.$i18n.locale;

        locale = this.getValidLocale(locale);

        this.locale = locale;

        this.emitter.on("localeChange", (locale) => {
            if (locale) {
                this.locale = this.getValidLocale(locale);

                if (typeof this.localeChangeCallback == "function") {
                    this.localeChangeCallback(this.locale);
                }
                // else{
                //     console.log('no callback', this.localeChangeCallback);
                // }
            }
        });
    },

    methods: {
        getValidLocale(locale) {
            return locale && ["en", "mm", "zh"].includes(locale)
                ? locale
                : this.user.locale
                ? this.user.locale
                : "en";
        },
    },
};
